(() => {
  if (window.AceiiProductMediaVideoModal) return;
  window.AceiiProductMediaVideoModal = true;

  const buttonSelector = "[data-aceii-product-video-entry]";

  const initialize = (button) => {
    if (!(button instanceof HTMLButtonElement) || button.dataset.aceiiVideoModalReady === "true") return;

    const modalId = button.getAttribute("aria-controls");
    const modal = modalId ? document.getElementById(modalId) : null;
    const panel = modal?.querySelector("[data-aceii-product-video-panel]");
    const body = modal?.querySelector("[data-aceii-product-video-body]");
    const template = modal?.querySelector("[data-aceii-product-video-template]");
    const closeButton = modal?.querySelector("[data-aceii-product-video-close]");

    if (!(modal instanceof HTMLDialogElement) || !panel || !body) return;

    button.dataset.aceiiVideoModalReady = "true";

    const resetPlayer = () => {
      const videos = body.querySelectorAll("video");
      videos.forEach((video) => {
        video.pause();
        video.currentTime = 0;
      });

      if (template && videos.length === 0) {
        body.querySelectorAll("iframe").forEach((iframe) => iframe.remove());
      }
    };

    const closeModal = () => {
      if (modal.open) modal.close();
    };

    const openModal = () => {
      if (template && !body.querySelector("iframe")) {
        body.append(template.content.cloneNode(true));
      }

      modal.showModal();

      const video = body.querySelector("video");
      const playPromise = video?.play();
      playPromise?.catch?.(() => {});
    };

    button.addEventListener("click", openModal);
    closeButton?.addEventListener("click", closeModal);
    modal.addEventListener("close", resetPlayer);

    modal.addEventListener("click", (event) => {
      if (event.target !== modal) return;

      const bounds = panel.getBoundingClientRect();
      const insidePanel =
        event.clientX >= bounds.left &&
        event.clientX <= bounds.right &&
        event.clientY >= bounds.top &&
        event.clientY <= bounds.bottom;

      if (!insidePanel) closeModal();
    });
  };

  const scan = (scope = document) => {
    if (scope instanceof Element && scope.matches(buttonSelector)) initialize(scope);
    scope.querySelectorAll?.(buttonSelector).forEach(initialize);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => scan(), { once: true });
  } else {
    scan();
  }

  document.addEventListener("shopify:section:load", (event) => scan(event.target));
})();
